/**
 * 使用 Storefront API 根据类型获取商品
 * @param {string} shop   店铺域名
 * @param {string} token  Storefront API 访问令牌
 * @param {string} type   商品类型
 * @returns {Promise<Array>}
 */
async function getProductsByTypeStorefront(shop, token, type) {
  const url = `https://${shop}/api/2024-01/graphql.json`;
  const query = `
    query getProductsByType($type: String!) {
      products(first: 50, query: $type) {
        edges {
          node {
            id
            title
            productType
            onlineStoreUrl
            handle
            featuredImage { url }
            priceRange {
                minVariantPrice {
                    amount
                    currencyCode
                }
                maxVariantPrice {
                    amount
                    currencyCode
                }
            }
            variants(first: 1) {
              edges {
                node {
                  price {
                    amount
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  const variables = { type: `product_type:${type}` };

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'X-Shopify-Storefront-Access-Token': token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ query, variables }),
  });

  const json = await response.json();
  if (json.errors) throw new Error(JSON.stringify(json.errors));
  return json.data.products.edges.map(edge => edge.node);
}

